import { Component } from '@angular/core';
import { LeaseDetailService } from '../../data/services/view/lease-detail.service';

@Component({
  selector: 'app-lease-active',
  templateUrl: './lease-active.component.html',
  styleUrls: ['./lease-active.component.scss']
})
export class LeaseActiveComponent {

  constructor(
    public leaseDetailService: LeaseDetailService
  ) { }

  get assets() {
    return this.leaseDetailService.data?.quotation?.quotationParameters
      ? this.leaseDetailService.data.quotation.quotationParameters.assets
      : this.leaseDetailService.data?.quotation?.assets ?? [];
  }

  /** QP del lease (poblada por el backend en findById). */
  get quotationParameters() {
    const qp = this.leaseDetailService.data?.quotationParameters;
    return qp && typeof qp === 'object' ? qp : null;
  }

  /**
   * Lease originado con activo provisional (cotización 2026-07-16): sin assets reales,
   * sin asset asignado, y con datos provisionales en la QP. Muestra la card provisional
   * con el botón "Asignar activo real" en lugar del empty state.
   */
  get isProvisionalAsset(): boolean {
    return this.getTotalAssetsCount() === 0
      && !this.leaseDetailService.data?.asset
      && !!(this.quotationParameters?.provitionalAsset || this.quotationParameters?.provitionalValue);
  }

  /** Tras asignar el activo real, recarga el detalle (el recálculo de la quote trae la card real). */
  onAssetAssigned(): void {
    this.leaseDetailService.getLeaseDetail();
  }

  /**
   * Returns the total count of assets
   */
  getTotalAssetsCount(): number {
    return this.assets?.length || 0;
  }

  /**
   * Returns severity for status badge
   */
  getStatusSeverity(status: string): string {
    const statusMap: { [key: string]: string } = {
      'Activo': 'success',
      'Arrendado': 'info',
      'Baja': 'danger',
    };
    return statusMap[status] || 'secondary';
  }

  /**
   * Returns icon for status badge
   */
  getStatusIcon(status: string): string {
    const iconMap: { [key: string]: string } = {
      'Activo': 'pi pi-check-circle',
      'Arrendado': 'pi pi-sync',
      'Baja': 'pi pi-times-circle',
    };
    return iconMap[status] || 'pi pi-circle';
  }

  /**
   * Checks if asset has any documents
   */
  hasDocuments(asset: any): boolean {
    if (!asset.acquisition) return false;
    
    return !!(
      asset.acquisition.invoicePdf ||
      asset.acquisition.invoiceXml ||
      asset.acquisition.paymentProof ||
      asset.acquisition.circulationCard ||
      asset.acquisition.vrn ||
      asset.acquisition.permisson ||
      asset.acquisition.inssurancePolice ||
      asset.acquisition.gps
    );
  }
}

